import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../shared/shared.css"
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";

import { Tooltip } from "primereact/tooltip";
import { Image } from "primereact/image";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";

const Vehicle = () => {
    const [frontImage, setFrontImage] = useState("");
    const [backImage, setBackImage] = useState("");
    const [vehicleImage, setVehicleImage] = useState("");
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const [vehcileTypeList, setVehcileTypeList] = useState([]);
    const [vehcileMakerList, setVehcileMakerList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [selectedVehicleType, setSelectedVehicleType] = useState(null);
    const [selectedMaker, setSelectedMaker] = useState(null);
    const [colorList, setColorList] = useState([]);
    const [provinceList, setProvinceList] = useState([]);
    const [cityByProvinceList, setCityByProvinceList] = useState([]);

    const [sittingCapacityList, setSittingCapacityList] = useState([]);
    const userId = useSelector((state) => state.authenticationSlice?.userId)
    const token = useSelector((state) => state.authenticationSlice?.token)
    const history = useHistory();
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [totalSize, setTotalSize] = useState(0);
    const fileUploadFrontRef = useRef(null);
    const fileUploadBackRef = useRef(null);

    const currentYear = new Date().getFullYear();
    const yearData = Array.from({ length: currentYear - 1970 + 1 }, (_, index) => ({
        id: index + 1,
        year: 1970 + index
    }));
    //Dropdown API Calls
   
    const getVehicleTypeList = async () => {
        const response = await dispatch(handleGetRequest("api/vehicletype/list", false));
        setVehcileTypeList(response?.data);
    };
    const getVehicleMakerList = async () => {
        const response = await dispatch(handleGetRequest("api/vehiclemake/list", false));
        setVehcileMakerList(response?.data);
    };
    const getColorList = async () => {
        const response = await dispatch(handleGetRequest("api/color/list", false));
        setColorList(response?.data);
    };
    const getProvinceList = async () => {
        const response = await dispatch(handleGetRequest("api/province/list", false));
        setProvinceList(response?.data);

    };
    const handleCityList = async (provinceId) => {
        const response = await dispatch(handlePostRequest("api/city/listbyprovince", { province: provinceId }, false, false));
        setCityByProvinceList(response?.data?.data);

    };
    const handleModelList = async () => {
        const response = await dispatch(handlePostRequest("api/vehiclemodel/list", {
            vehicleType: selectedVehicleType,
            vehicleMake: selectedMaker
        }
            , false, false));
        setModelList(response?.data?.data);

    };
   
    useEffect(() => {
        getVehicleTypeList()
        getVehicleMakerList()
        getColorList();
        getProvinceList();
        // handleCityList();
        // getSittingCapacityList()
    }, []);
    useEffect(() => {
        if (selectedVehicleType && selectedMaker) {
            handleModelList();
        }

    }, [selectedVehicleType, selectedMaker])


    const validationSchema = Yup.object().shape({
        model: Yup.mixed().required("This field is required."),
        year: Yup.mixed().required("This field is required."),
        registrationNumber: Yup.mixed().required("This field is required."),
        minMileage: Yup.mixed().required("This field is required."),
        color: Yup.mixed().required("This field is required."),
        seatingCapacity: Yup.mixed().required("This field is required."),
        registrationProvince: Yup.mixed().required("This field is required."),
        registrationCity: Yup.mixed().required("This field is required."),
    });
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            userId: "",
            model: "",
            registrationNumber: "",
            registrationCity: "",
            registrationProvince: "",
            year: "",
            minMileage: "",
            maxmileage: "0",
            color: "",
            seatingCapacity: "",
            AC: true,
            heater: false,
            token: "",
            documents: [{
                type: "registrationCard",
                frontImage: "",
                backImage: "",
                vehicleImage
            }]
        },

        onSubmit: async (data) => {
            let payload = {
                userId: userId,
                model: data?.model,
                registrationNumber: data?.registrationNumber,
                registrationCity: data?.registrationCity,
                registrationProvince: data?.registrationProvince,
                year: data?.year,
                minMileage: data?.minMileage,
                maxmileage: "0",
                color: data?.color,
                seatingCapacity: data?.seatingCapacity,
                AC: true,
                heater: false,
                token: token,
                documents: [{
                    type: "registrationCard",
                    frontImage: frontImage,
                    backImage: backImage,
                    vehicleImage: vehicleImage
                }],
            }
            // setSaveBtnLoading(true);

            try {
                setSaveBtnLoading(true);
                const response = await dispatch(handlePostRequest("api/vehicle", payload, true, true))
                formik.resetForm();
                setSaveBtnLoading(false);
                return response

            }
            catch (error) {
                console.error(error)
                // setSaveBtnLoading(false);
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const onTemplateSelect = (e, type) => {
        let _totalSize = totalSize;
        let file = e.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;
                if (type === "front") {
                    setFrontImage(base64Image);
                } else if (type === "back") {
                    setBackImage(base64Image);
                }
                else if (type === "vehicle") {
                    setVehicleImage(base64Image);
                }
            };
            reader.readAsDataURL(file);
        }

        _totalSize += file.size || 0;
        setTotalSize(_totalSize);
    };


    const onTemplateUpload = (e) => {
        let _totalSize = 0;
        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });
        setTotalSize(_totalSize);
        toast.success("File Uploaded")
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };


    const headerTemplate = (options) => {
        const { className, chooseButton, cancelButton } = options;
        // const value = totalSize / 10000;
        // const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {/* {cancelButton} */}
                <div className="flex align-items-center gap-3 ml-auto">
                    {/* <span>{formatedValue} / 1 MB</span> */}
                    {/* <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar> */}
                </div>
            </div>
        );
    };


    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap" style={{ position: 'relative', justifyContent: 'center', }}>
                <div className="flex justify-content-center align-items-center" >
                    <Image alt={file.name} role="presentation" src={file.objectURL} width="100%" style={{ marginTop: "1rem" }} />
                </div>

                <Button
                    type="button"
                    icon="pi pi-times"
                    className="p-button-outlined p-button-rounded p-button-danger"
                    style={{
                        position: "absolute",
                        top: "-15px",
                        right: " -5px",
                        padding: "1rem",
                        fontSize: "0.5rem",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => onTemplateRemove(file, props.onRemove)}
                />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image xl:text-4xl lg:text-xl md:text-2xl mt-2 md:mt-1 p-5 xl:p-3 lg:p-2 md:p-1 " style={{ fontSize: '2rem', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1rem', color: 'var(--text-color-secondary)' }} className="my-3">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'p-button-rounded p-button-outlined text-white' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'p-button-rounded p-button-outlined text-white' };


    return (
        <>
            <div className="col-12">
                <div className='flex justify-content-center' style={{ gap: "3rem" }}>
                    <form className="" style={{ width: "80vw" }} onSubmit={formik.handleSubmit}>
                        <div className="w-full surface-card py-4 px-4 ">
                            <h4 className='text-white m-4 mb-2 mt-1'>Vehicle Details</h4>
                            <div className="flex flex-column xl:flex-row lg:flex-row md:flex-row justify-content-between col-12 m-2">
                                <div className="flex flex-column col-12 xl:col-6 lg:col-6 md:col-6 sm:col-12 xl-pr-2 xl:pl-2">
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label htmlFor="vehicleType">Vehicle Type</label>
                                        <Dropdown id="vehicleType" name="vehicleType" placeholder="--Select Vehicle Type--" options={vehcileTypeList} optionLabel="type" optionValue="_id" value={formik.values.vehicleType}
                                            // onChange={formik.handleChange} 

                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                setSelectedVehicleType(e.target.value);
                                            }}
                                            className="w-full mb-2" />


                                        {/* </span> */}
                                        {getFormErrorMessage("vehicleType")}
                                    </div>

                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>Vehicle Maker</label>
                                        <Dropdown id="maker" name="maker" placeholder="--Select Maker--" options={vehcileMakerList} optionLabel="make" optionValue="_id" value={formik.values.maker}
                                            // onChange={formik.handleChange} 
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                setSelectedMaker(e.target.value);
                                            }}
                                            className="w-full mb-2" />

                                        {/* </span> */}

                                        {getFormErrorMessage("maker")}
                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>Modal</label>
                                        <Dropdown id="model" name="model" placeholder="--Select Model--" options={modelList} optionLabel="model" optionValue="_id" value={formik.values.model} onChange={formik.handleChange} className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("model")}
                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}

                                        <label>Registration Number</label>
                                        <InputText id="registrationNumber" type="tel" name="registrationNumber" placeholder="Enter Vehicle Registration No" value={formik.values.registrationNumber} onChange={formik.handleChange} className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("registrationNumber")}


                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>Year</label>
                                        <Dropdown id="year" name="year" placeholder="--Select Year--" options={yearData} optionLabel="year" optionValue="year" value={formik.values.year} onChange={formik.handleChange} className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("year")}
                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>AvgMileage</label>
                                        <InputText id="minMileage" type="text" name="minMileage" placeholder="Enter Average Mileage" value={formik.values.minMileage} onChange={formik.handleChange} className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("minMileage")}
                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>Color</label>
                                        <Dropdown id="color" name="color" placeholder="--Select color--" options={colorList} optionLabel="color" optionValue="_id" value={formik.values.color} onChange={formik.handleChange} className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("color")}
                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>Sitting Capacity</label>
                                        <Dropdown id="seatingCapacity" name="seatingCapacity" placeholder="--Select Sitting Capacity--" options={modelList} optionLabel="seatingCapacity" optionValue="seatingCapacity" value={formik.values.seatingCapacity} onChange={formik.handleChange} className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("seatingCapacity")}
                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>Province</label>
                                        <Dropdown id="registrationProvince" name="registrationProvince" placeholder="--Select Province--" options={provinceList} optionLabel="name" optionValue="_id" value={formik.values.registrationProvince}
                                            // onChange={formik.handleChange} 
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                handleCityList(e.target.value);
                                            }}
                                            className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("registrationProvince")}
                                    </div>
                                    <div className="m-2 ml-2 mr-2">
                                        {/* <span className="p-float-label"> */}
                                        <label>City</label>
                                        <Dropdown id="registrationCity" name="registrationCity" placeholder="--Select City--" options={cityByProvinceList} optionLabel="city" optionValue="_id" value={formik.values.registrationCity} onChange={formik.handleChange} className="w-full mb-2" />

                                        {/* </span> */}
                                        {getFormErrorMessage("registrationCity")}
                                    </div>
                                </div>
                                <div className="flex flex-column col-12 xl:col-6 lg:col-6 md:col-6 sm:col-12">
                                    <h5 className="md:mb-3 md:mt-1 text-xl xl:text-xl lg:text-xl md:text-md sm:text-md">Vehicle Registration </h5>
                                    <div className="flex flex-column xl:flex-row lg:flex-row md:flex-column xl:mt-3 lg:mt:0 md:mt-0 sm:mt-3">
                                        <div className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12">
                                            <h6 className="text-base xl:text-xl lg:text-xl md:text-base sm:text-base">Front Image (Required)</h6>

                                            <Toast ref={toast}></Toast>
                                            <Tooltip target="" content="Choose" position="bottom" />

                                            <FileUpload
                                                ref={fileUploadFrontRef}
                                                name="demo[]"
                                                url="/api/upload"
                                                accept="image/*"
                                                onUpload={onTemplateUpload}
                                                onSelect={(e) => onTemplateSelect(e, "front")}
                                                onError={onTemplateClear}
                                                onClear={onTemplateClear}
                                                headerTemplate={headerTemplate}
                                                itemTemplate={itemTemplate}
                                                emptyTemplate={emptyTemplate}
                                                chooseOptions={chooseOptions}
                                            />
                                        </div>
                                        <div className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12">
                                            <h6 className="text-base xl:text-xl lg:text-xl md:text-base sm:text-base">Back Image (Required)</h6>
                                            <Toast ref={toast}></Toast>
                                            <Tooltip target="" content="Choose" position="bottom" />

                                            <FileUpload
                                                ref={fileUploadBackRef}
                                                name="demo[]"
                                                url="/api/upload"
                                                accept="image/*"
                                                onUpload={onTemplateUpload}
                                                onSelect={(e) => onTemplateSelect(e, "back")}
                                                onError={onTemplateClear}
                                                onClear={onTemplateClear}
                                                headerTemplate={headerTemplate}
                                                itemTemplate={itemTemplate}
                                                emptyTemplate={emptyTemplate}
                                                chooseOptions={chooseOptions}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex flex-row justify-content-center">
                                        <div className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12 xl:mt-5 lg:mt:1 md:mt-1 sm:mt-3 s">
                                            <h6 className="text-base xl:text-xl lg:text-xl md:text-base sm:text-base">Vehicle Image (Required)</h6>
                                            <Toast ref={toast}></Toast>
                                            <Tooltip target="" content="Choose" position="bottom" />

                                            <FileUpload
                                                ref={fileUploadBackRef}
                                                name="demo[]"
                                                url="/api/upload"
                                                accept="image/*"
                                                onUpload={onTemplateUpload}
                                                onSelect={(e) => onTemplateSelect(e, "vehicle")}
                                                onError={onTemplateClear}
                                                onClear={onTemplateClear}
                                                headerTemplate={headerTemplate}
                                                itemTemplate={itemTemplate}
                                                emptyTemplate={emptyTemplate}
                                                chooseOptions={chooseOptions}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <Button label="Add" loading={saveBtnLoading} type="submit" className="block font-medium mx-auto mt-5 text-lg w-9rem" />
                            </div>
                        </div>
                    </form>
                </div >
            </div >
        </>
    )
}

export default Vehicle